import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap, map } from "rxjs/operators";

@Injectable()
export class DataClipService {
  constructor(private http: HttpClient) {}

  public getCreditBehaviourReport(): Observable<any> {
    return this.http
      .get("https://data.heroku.com/dataclips/lnxaouiksqspdsrtrvvkwlfmkcgx.json")
      .pipe(tap((_) => console.log("DataClipService.getCreditBehaviourReport: Ok")))
      .pipe(
        map((response) => {
          return this.buildReadableJson(response);
        })
      );
  }

  public buildReadableJson(heroku_json): any {
    const fields = heroku_json.fields;
    return heroku_json.values.map((values) => {
      const row = values.reduce((accum, value, index) => {
        return { ...accum, [fields[index]]: value };
      }, {});
      return row;
    });
  }
}
